import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import PasswordModal from "../../common/PasswordModal";
import Card from "../../components/cards";
import DiscoverMoreSection from "../../components/discoverMore";
import Testimonial from "./../../components/discoverMore/Testimonial";
import Areas from "./../../components/discoverMore/Areas";
import Workings from "./../../components/discoverMore/Workings";
import Safety from "./../../components/discoverMore/Safety";
import GeneralVB from "./../../components/discoverMore/GeneralVB";
import JoinNow from "./../../components/discoverMore/JoinNow";
import Footer from "../../components/discoverMore/Footer";

import { PrimaryButton } from "../../common/Buttons";
import { navigateToFirstPage } from "../../utils/Utilities";
import { getUser } from "../../services/profile";

import "./homepage.scss";
import { allowedUsers } from "../../constants/constants";
import { useSelector } from "react-redux";
import Introduction from "../../components/discoverMore/Introduction";
import VideoSection from "../../components/videoSection";
import styled from "styled-components";

const Homepage = () => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user);
  const [passwordModal, setPasswordModal] = useState(false);

  const navigate = useNavigate();
  const createUserName = () => {
    const lastName = localStorage.getItem("lastName");
    const userGender = localStorage.getItem("userGender");
    return (
      lastName && `${userGender === "male" ? t("mr") : t("ms")} ${lastName}`
    );
  };

  return (
    <>
      <Container maxWidth="lg">
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          height="auto"
          spacing={5}
          className="homepage"
          sx={{
            [`@media (min-width: 2560px)`]: {
              minHeight: "88vh",
            },
            [`@media (max-width: 2559px)`]: {
              minHeight: "80vh",
            },
            
          }}
        >
          <Grid item md={5} className="left-sec">
            <Typography
              variant="h2"
              fontWeight={800}
              marginBottom={2}
              fontFamily="Futura !important"
            >
              {t("FutureCare")}
            </Typography>

            <Box
              sx={{
                width: "80%",
              }}
            >
              <Typography
                variant="inherit"
                fontWeight="bold"
                marginBottom="0.5rem"
                fontSize="20px"
                color="#444561"
                fontFamily="WixMadefor"
              >
                {t("welcome")}, {createUserName()}
              </Typography>
              <Typography
                variant="inherit"
                fontSize="20px"
                // fontWeight={400}
                marginBottom="2.5rem"
                fontFamily="WixMadefor"
                color="#444561"
              >
                {t("home-page-heading")}
              </Typography>
              <PrimaryButton
                title={
                  <Typography fontSize="22px" fontWeight="bold">
                    {t("lets-get-started")}
                  </Typography>
                }
                fullWidth={true}
                textTransform="initial"
                width="100%"
                borderRadius="12px"
                click={() => {
                  navigateToFirstPage(navigate);
                }}
              />
            </Box>
            {allowedUsers[0] === user?.role?.roleName && (
              <div className="get-starter-content">
                <div onClick={() => navigate("/get-started")}>
                  <p>
                    {t("what-will-i-need-to-get-started")}
                    <span>
                      <img src="/assets/icons/arrow_right_alt_FILL0_wght600_GRAD0_opsz48 (1).png" />
                    </span>
                  </p>
                </div>
              </div>
            )}
          </Grid>
          <Grid item md={7} className="right-sec">
            <Box
              component="img"
              alt="Login"
              src="/assets/images/login-image.png"
              width="100%"
            />
          </Grid>
        </Grid>
      </Container>

      <DiscoverMoreSection
      // discoverMoreShow={
      //   allowedUsers[0] === user?.role?.roleName ? true : false
      // }
      />

      <Box as="section" className="introduction-section">
        <Container
          sx={{
            [`@media (min-width: 1500px)`]: {
              maxWidth: "1400px",
            },
          }}
        >
          <Introduction />
        </Container>
      </Box>

      <Box as="section" backgroundColor="#F5F5F5">
        <Container>
          <Areas />
        </Container>
      </Box>

      <Container sx={{
          [`@media (min-width: 1500px)`]: {
            maxWidth: "1400px",
          },
          [`@media (min-width: 3800px)`]: {
            maxWidth: "3000px",
          },
        }}
      >
        <Workings />
      </Container>
      <Box as="section" backgroundColor="#E3E3E318">
        <Container sx={{
          [`@media (min-width: 1500px)`]: {
            maxWidth: "1400px",
          },
          [`@media (min-width: 3800px)`]: {
            maxWidth: "3000px",
          },
        }}
      >
          <Safety />
        </Container>
      </Box>

      <Container sx={{
          [`@media (min-width: 1500px)`]: {
            maxWidth: "1400px",
          },
          [`@media (min-width: 3800px)`]: {
            maxWidth: "3000px",
          },
        }}
      >
        <GeneralVB />
      </Container>
      <Box as="section" backgroundColor="#69617D40">
        <Container sx={{
          [`@media (min-width: 1500px)`]: {
            maxWidth: "1400px",
          },
          [`@media (min-width: 3800px)`]: {
            maxWidth: "3000px",
          },
        }}
      >
          <Testimonial />
        </Container>
      </Box>
      <Container sx={{
          [`@media (min-width: 1500px)`]: {
            maxWidth: "1400px",
          },
          [`@media (min-width: 3800px)`]: {
            maxWidth: "3000px",
          },
        }}
      >
        <JoinNow />
      </Container>
      <Footer />

      {/* {passwordModal && (
        <PasswordModal
          handleSubmit={(values, setErrors) => {
            setPasswordModal(false);
            // if (values?.password === password) {
            // } else
            //   setErrors({
            //     password: "Authentication failed",
            //   });
          }}
        />
      )} */}
    </>
  );
};

export default Homepage;
